// @flow
import React from 'react'
import LoadableSelect from './LoadableSelect'
import styled, { type StyledComponent } from 'styled-components'

import type { Public } from '../types'
import { translateFunc, translations } from '../../shared/localize'
import type {
  CommonPublicProps,
  ProviderPublicProps
} from '../../redux/ducks/audienceEdit/reducers'

const t = translateFunc(translations.audience_edit.public_fields)

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
`

type Props = {|
  currentAdAccountId: number,
  publicObject?: Public,
  onPublicChange: (Public) => void,
  placeholder: string,
  isEditDisabled: boolean,
  isOrtAccounts: boolean,
  publicProps: ProviderPublicProps,
  commonPublicProps: CommonPublicProps
|}

export default function SocialPublicSelect(props: Props) {
  const { isOrtAccounts, publicProps, commonPublicProps } = props

  const isConnected = isOrtAccounts
    ? publicProps.isTokenPresent && publicProps.hasAccountPublicsWithAccess
    : publicProps.isAccountConnected
  const oauthLink = isOrtAccounts ? publicProps.publicsOauthPath : publicProps.connectionsOauthPath

  const providerNotConnectedText = isOrtAccounts
    ? t('provider_not_connected_ort')
    : t('provider_not_connected_partner')

  const connectProviderLinkText = isOrtAccounts
    ? t('connect_provider_ort')
    : t('connect_provider_partner')
  const redirectPath = isOrtAccounts
    ? commonPublicProps.publicsPath
    : commonPublicProps.connectionsPath

  return (
    <Wrapper>
      {isConnected ? (
        <LoadableSelect
          currentAdAccountId={props.currentAdAccountId}
          selectedValue={props.publicObject}
          loadUrl={publicProps.getPublicsUrl}
          refreshTokenUrl={oauthLink}
          onChange={props.onPublicChange}
          selectOptions={{
            placeholder: props.placeholder,
            isDisabled: props.isEditDisabled
          }}
        />
      ) : (
        <div>
          {providerNotConnectedText}:{' '}
          <a target="_blank" href={publicProps.isTokenPresent ? redirectPath : oauthLink}>
            {connectProviderLinkText}
          </a>
        </div>
      )}
    </Wrapper>
  )
}
